<template>
  <span v-bind="$attrs"><slot></slot></span>
</template>
<script>
export default {
  name: "TangramText",
  inheritAttrs: false,
};
</script>
<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Red+Hat+Display:wght@400;600&display=swap");

:root {
  font-family: "Red Hat Display", sans-serif;
}

span {
  font-style: normal;
  font-weight: 400;
  font-size: 1.25rem;
  line-height: 150%;
}
</style>
